import { GuidedTour, Orientation } from "ngx-guided-tour";

export const welcomeAnnouncementTour: GuidedTour = {
    tourId: 'welcomeAnnouncement',
    useOrb: false,
    steps: [
        {
            title: 'Edital Verticalizado',
            selector: '.mt-4>.col>.card',
            content: 'Aqui nesta tela você tem um resumo do seu avanço no Edital e do seu desempenho nos tópicos de cada disciplina.',
            orientation: Orientation.Bottom,
            highlightPadding: 5,
            action: () => {
                (document.getElementsByClassName('subject-header').item(0) as HTMLElement)?.click();
                setTimeout(() => {
                    (document.getElementsByClassName('subject-header').item(0) as HTMLElement)?.click();
                }, 100);
            },
            closeAction: () => {
                (document.getElementsByClassName('subject-header').item(0) as HTMLElement)?.click();
            }
        },
        {
            title: 'Edital Verticalizado',
            selector: '.custom-control-input',
            content: 'Marque aqui os tópicos que você já terminou de estudar a teoria.',
            orientation: Orientation.Right,
            highlightPadding: 80,
        },
        {
            title: 'Edital Verticalizado',
            selector: 'tr>th:nth-child(7)',
            content: 'Aqui você pode colocar links externos para cada tópico do Edital e facilitar seu acesso. Coloque links de videoaulas, PDFs, cadernos de questões, resumos, mapas mentais, etc.',
            orientation: Orientation.Left,
            highlightPadding: 30,
        }
    ]
};